import React, { ReactNode } from 'react';
import { useTestAB } from '@catalogo/core-experiments';
import { ComponentType } from 'react';

type ComponentProps = {
  children: ReactNode;
  marketSearchExperiment: string | undefined;
};

export const withMarketSearch = <P extends unknown>(Component: ComponentType) => (props: P) => {
  const experiment = useTestAB('EXP_CAT_DISC_MARKET_SEARCH');

  const componentProps = {
    marketSearchExperiment: experiment?.toLowerCase(),
  } as ComponentProps;

  return <Component {...props} {...componentProps} />;
};
